import React from 'react'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

const HighlightText = ({children, ...props}) => {
    return (
        <Text as="span" color="yellow.400" {...props}>
            {children}
        </Text>
    )
}

HighlightText.propTypes = {
    children: PropTypes.node,
    props: PropTypes.object
}

export default HighlightText
